import React from "react";

export default function MonogramMultibutton({ firstButton, secondButton, fontsPerDrawer }) {
  const {
    children: firstButtonChildren,
    onClick: firstButtonOnClick,
    ...otherFirstButtonProps
  } = firstButton;
  const {
    children: secondButtonChildren,
    onClick: secondButtonOnClick,
    ...otherSecondButtonProps
  } = secondButton;

  // check if there are 2 objects in the fontsPerDrawer object
  if (Object.keys(fontsPerDrawer).length !== 2) {
    return;
  }

  return (
    <div className="monogram-multibutton monogram-multibutton--pink">
      <button
        className="monogram-button"
        onClick={firstButtonOnClick}
        {...otherFirstButtonProps}
        dangerouslySetInnerHTML={{ __html: firstButtonChildren }}
      />
      <button
        className="monogram-button"
        onClick={secondButtonOnClick}
        {...otherSecondButtonProps}
        dangerouslySetInnerHTML={{ __html: secondButtonChildren }}
      />
    </div>
  );
}
